import React, { useMemo } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../../../constants/aampeTheme';

import {
    getFormulaScheduleTimeText,
    getFormulaStartEndDate,
} from 'helpers/formulaHelpers';

import {
    FormulaDetailModel,
    FormulaSchedulingOptions,
    FormulaStartStopType,
} from 'models/formula.model';
import { TimingSlotsModel } from 'models/timing-slots.model';

import { SummaryItem } from './SummaryItem';

export const TimeRangeSummary = ({
    formula,
    schedulingType,
    timingSlots,
    setShowTimeSlotsModal,
}: {
    formula: FormulaDetailModel;
    timingSlots?: TimingSlotsModel[];
    schedulingType: FormulaSchedulingOptions;
    setShowTimeSlotsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const formulaScheduleData = useMemo<FormulaStartStopType>(
        () => getFormulaStartEndDate(formula),
        [formula],
    );
    const dateText = useMemo<string>(
        () =>
            getFormulaScheduleTimeText(
                formula.is_controlled_message,
                formulaScheduleData.send_start,
                formulaScheduleData.send_stop,
                formula?.timezone,
            ),
        [formula, formulaScheduleData],
    );

    const timeslotsLength = useMemo<number>(() => {
        if (formula && formula?.time_slot_ids?.length) {
            return formula.time_slot_ids.length;
        }
        return timingSlots?.length || 0;
    }, [timingSlots, formula]);
    return (
        <SummaryItem
            label="Time Range"
            value={dateText}
            subValue={
                <span
                    onClick={() => setShowTimeSlotsModal(true)}
                    style={{
                        color: '#1a4b9b',
                        cursor: 'pointer',
                    }}
                >
                    {schedulingType ===
                        FormulaSchedulingOptions.AUTOMATED_WITH_GUARDRAILS && (
                        <ValueLink onClick={() => setShowTimeSlotsModal(true)}>
                            View {timeslotsLength} timeslots
                        </ValueLink>
                    )}
                </span>
            }
        />
    );
};

const ValueLink = styled.span({
    color: aampeTheme.colors.solidA01,
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.medium,
    cursor: 'pointer',
});
